import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { useCitadel } from "@/hooks/use-citadel";
import { InviteUsersModal } from "@/modals/organizations/invite-users-modal";

export function OrganizationMembersMenu() {
	/** Hooks */
	const { t } = useTranslation();
	const inviteUsersModal = useDisclosure();
	const { citadel } = useCitadel();

	/** Computed */
	// The people list is the one organisation-settings tab an ordinary member reaches, and this is
	// the only control on it. `POST /organizations/invite` is gated on `create User`, a subject the
	// base set holds no rule for at all, so without the guard the tab hands every member a button
	// whose only outcome is a refusal. Three states rather than two: a rule list still in flight is
	// not a denial, so the control stays usable while it loads — the same guard `Can` documents.
	const inviteIsDenied = !!citadel && citadel.cannot("create", "User");

	/** Render */
	return (
		<React.Fragment>
			<Button
				onClick={inviteUsersModal.onOpen}
				icon={<Icon name="UserPlus" />}
				variant="primary"
				isDisabled={inviteIsDenied}
			>
				{t("users.invite_users")}
			</Button>
			{inviteUsersModal.isOpen && (
				<InviteUsersModal
					isOpen={inviteUsersModal.isOpen}
					onClose={inviteUsersModal.onClose}
				/>
			)}
		</React.Fragment>
	);
}
